var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        staticClass: "screenfull-svg",
        attrs: {
          t: "1508738709248",
          viewBox: "0 0 128 128",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "2069",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "128px",
          height: "128px"
        },
        on: { click: _vm.click }
      },
      [
        _c("path", {
          attrs: {
            fill: "#409EFF",
            d:
              "M63.603,71.905c-2.317,0-4.249-1.752-4.249-4.016V4.015c0-2.19,1.854-4.015,4.249-4.015\n\ts4.248,1.752,4.248,4.015V67.89C67.851,70.079,65.92,71.905,63.603,71.905z"
          }
        }),
        _c("path", {
          attrs: {
            fill: "#2F3133",
            d:
              "M86.104,14.958c-2.109-0.783-4.521,0.214-5.351,2.279c-0.829,1.995,0.227,4.274,2.336,5.058\n\tc27.661,9.972,41.529,39.318,30.979,65.459c-5.805,14.317-17.787,24.717-31.883,29.489c-0.903,0.285-1.884,0.569-2.787,0.854\n\tc-0.755,0.215-1.585,0.428-2.338,0.642c-0.904,0.214-1.808,0.356-2.713,0.569l-2.487,0.428c-0.904,0.143-1.733,0.214-2.638,0.285\n\tc-0.903,0.071-1.735,0.143-2.639,0.213c-0.904,0.072-1.733,0.072-2.638,0.072s-1.733,0-2.638-0.072\n\tc-0.904-0.07-1.733-0.142-2.638-0.213c-0.905-0.071-1.734-0.143-2.638-0.285l-2.487-0.428c-0.905-0.142-1.81-0.355-2.714-0.569\n\tc-0.753-0.214-1.582-0.427-2.336-0.642c-0.904-0.285-1.884-0.569-2.789-0.854c-14.169-4.843-26.078-15.172-31.881-29.489\n\tC3.198,61.614,17.066,32.338,44.727,22.366c2.11-0.783,3.166-2.992,2.336-5.057s-3.166-2.991-5.352-2.279\n\tC9.98,26.498-5.998,60.333,6.212,90.462c6.557,16.169,19.823,27.922,35.726,33.621v0.07c0.376,0.143,0.754,0.215,1.13,0.356\n\tc1.055,0.355,2.111,0.713,3.241,0.997c0.904,0.284,1.809,0.499,2.713,0.713c1.055,0.284,2.111,0.428,3.166,0.642\n\tc0.98,0.213,1.885,0.355,2.864,0.497c0.98,0.143,2.036,0.215,3.016,0.356c0.979,0.072,1.959,0.214,3.014,0.214\n\tc1.056,0,2.035,0.071,3.016,0.071c0.979,0,2.035,0,3.015-0.071c0.979-0.07,1.96-0.142,3.015-0.214\n\tc0.979-0.071,2.035-0.214,3.015-0.356c0.979-0.142,1.884-0.284,2.863-0.497c1.056-0.214,2.111-0.357,3.166-0.642\n\tc0.904-0.214,1.81-0.499,2.715-0.713c1.056-0.284,2.184-0.642,3.239-0.997c0.378-0.142,0.755-0.214,1.13-0.356v-0.07\n\tc15.904-5.699,29.17-17.522,35.726-33.621C134.04,60.333,118.063,26.498,86.104,14.958z"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }